import { QK } from '@/js/consts/query-keys';
import { useQuery } from '@tanstack/vue-query';
import { getUsersByFilter } from './userApi';
import { computed, Ref } from 'vue';

export const useGetUsersByFilter = (filter: Ref<string>) => {
    return useQuery({
        queryKey: computed(() => [QK.USERS.SEARCH, filter.value]),
        queryFn: () => getUsersByFilter(filter.value),
        enabled: computed(() => typeof filter.value === 'string' && filter.value.length >= 2),
    });
};
